import React from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import { Input } from "../../../../components/form/Input/Input";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { FILTER_OPTIONS } from "../constants";

export const General = ({ register, control, isEditMode, orgRoles }) => {
  const { dateFormats, timeFormats, global2fa, environment } = useSelector(
    (state) => state.organizations.commonSettings
  );

  return (
    <>
      <div className="admin-organizations__section">
        <Input
          label="Business name"
          htmlFor="business_name"
          customProps={register("business_name")}
        />

        <div className="admin-organizations__dropdown">
          <p>Category</p>
          <Controller
            control={control}
            name="category"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.categoryList}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__date">
          <p>Deactivate on</p>

          <Controller
            control={control}
            name="deactivate_on"
            render={({ field: { onChange, onBlur, value } }) => {
              return (
                <ReactDatePicker
                  showDefaultInputIcon={false}
                  showClearDate
                  onBlur={onBlur}
                  startDate={value}
                  allowAllDays
                  updateDates={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Active years</p>
          <Controller
            control={control}
            name="active_years"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  includeSelectAll
                  enableOnly
                  valueKey="name"
                  options={FILTER_OPTIONS.activeYears}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Currency</p>
          <Controller
            control={control}
            name="currency"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.currencyList}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Date format</p>
          <Controller
            control={control}
            name="date_format"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={dateFormats}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Time format</p>
          <Controller
            control={control}
            name="time_format"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={timeFormats}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        {isEditMode && (
          <div className="admin-organizations__dropdown">
            <p>Default client role</p>
            <Controller
              control={control}
              name="default_client_role_id"
              render={({ field: { onChange, onBlur, value } }) => {
                return (
                  <Dropdown
                    onBlur={onBlur}
                    height={275}
                    haveOnSelectChange
                    options={orgRoles}
                    selectedFilters={value}
                    numberDisplayed={0}
                    onSelectChange={(data) => onChange(data)}
                  />
                );
              }}
            />
          </div>
        )}

        <div className="admin-organizations__dropdown">
          <p>Beginning of week</p>
          <Controller
            control={control}
            name="beginning_of_week"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  options={FILTER_OPTIONS.beginningOfWeek}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
        <Input label="Client name" htmlFor="client_name" customProps={register("client_name")} />

        {!isEditMode && <div className="admin-organizations__empty" />}
      </div>

      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Inactive users</p>
          <Controller
            control={control}
            name="inactive_clients"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="inactiveUsers"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>

        {global2fa && (
          <div className="switch">
            <p className="switch__title">Use 2fa</p>
            <Controller
              control={control}
              name="use_2fa"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="use2fa"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
        )}

        <div className="switch">
          <p className="switch__title">Inactive organization</p>
          <Controller
            control={control}
            name="inactive"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="inactiveOrganization"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
        {environment !== "production" && (
          <div className="switch">
            <p className="switch__title">Demo</p>
            <Controller
              control={control}
              name="is_demo"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="isDemo"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};
